import { Component, Host, h, State, Element, Method, Event, EventEmitter } from '@stencil/core';

/**
 * @since 202203
 * @status Stable
 *
 * @slot - Custom loader content.
 *
 * @part loader - Main loader container.
 */
@Component({
  tag: 'o2-loader',
  styleUrl: 'loader.scss',
  shadow: true,
})
export class O2Loader {
  private hasSlot: boolean;

  /**
   * Toggle visibility of loader
   */
  @State() isVisible: boolean = false;

  @Element() private el!: HTMLO2LoaderElement;

  private isBodyChild = this.el.parentElement.nodeName.toLowerCase() === 'body' ? true : false;

  /**
   * Show loader
   */
  @Method()
  async show() {
    this.isVisible = true;
    this.o2Show.emit();
  }

  /**
   * Hide loader
   */
  @Method()
  async hide() {
    this.isVisible = false;
    this.o2Hide.emit();
  }

  /**
   * Emitted when the loader has been opened.
   */
  @Event() o2Show!: EventEmitter<any>;

  /**
   * Emitted when the loader has been hidden.
   */
  @Event() o2Hide!: EventEmitter<any>;

  connectedCallback() {
    this.hasSlot = this.el.children.length > 0;
  }

  render() {
    return (
      <Host>
        <div class={`loader ${this.isVisible ? 'loader--visible' : ''} ${this.isBodyChild ? 'loader--body-child' : ''}`} part="loader">
          {this.hasSlot ? <slot /> : <o2-icon name="loading" color="white" size={80}></o2-icon>}
        </div>
      </Host>
    );
  }
}
